import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'; 
import { CSVLink } from 'react-csv';
import { useQuery } from '@apollo/client';
import Query from '../graphql/query';
import moment from 'moment';
import ActivityIndicator from '../components/common/ActivityIndicator';
import NavigationBar from 'components/common/NavigationBar';
import ViewType from 'components/common/ViewType';
import ViewRange from 'components/common/ViewRange';
import IndexLineChart from 'components/Chart/Line/IndexLineChart';
import CustomGaugeChart from '../utils/customGaugeChart';
import { dateFormats } from '../utils/constants';


const KoreanNewsIndex = () => {
  const [csvData, setCSVData] = useState([]);
  const [csvFileName, setCSVFileName] = useState("");
  const [viewType, setViewType] = useState("MONTH");
  const [startDate, setStartDate] = useState(moment().subtract(1, 'Y').format(dateFormats.dash_month));
  const [endDate, setEndDate] = useState(moment().format(dateFormats.dash_month));
  const [currentMonth, setCurrentMonth] = useState(moment().format(dateFormats.dash_month));
  const [koreaIndex, setKoreaIndex] = useState();
  const [koreaSignal, setKoreaSignal] = useState();

  const viewTypeChangeHandler = (value) =>  {
    const dateType = value === 'MONTH'? dateFormats.dash_month : dateFormats.dash_day;
    setStartDate(moment(startDate).format(dateType));
    setEndDate(moment().format(dateType));
    setViewType(value)
  };

  const viewRangeHandler = (startDate, endDate) => {
    const dateType = viewType === 'MONTH'? dateFormats.dash_month : dateFormats.dash_day;
    setStartDate(moment(startDate).format(dateType));
    setEndDate(moment(endDate).format(dateType));
  }

  const { loading:loadingIndex, data:chartData, refetch:refreshKoreaIndex } = useQuery(Query.getKoreaIndex, {
    variables: {start: startDate, end: endDate, interval: viewType}
  });

  useEffect(() => {
    refreshKoreaIndex();
  }, [startDate, endDate, refreshKoreaIndex])

  useEffect(() => {
    if(chartData){
      setKoreaIndex(chartData.koreaIndex)
    }
  }, [chartData]);

  useEffect(() => {  
    if(chartData) {
      const data = chartData.koreaIndex;

      // react-csv에서 사용가능한 형태로 재가공한다
      const csvData = data.date.map((date, i) => {
        return {
          index: date,
          kospi: data.index[i],
          ews: data.ews[i]
        }
      })

      setCSVData(csvData)
      setCSVFileName("KORIndexCSV.csv")
    }
  }, [chartData, viewType]);

  const { loading:loadingSummary, refetch:refreshSummary } = useQuery(Query.getKoreaSummary, {
    variables: {date: currentMonth}
  });

  useEffect(() => {
    setKoreaSignal();
    refreshSummary({date: currentMonth})
    .then((data) => {
      setKoreaSignal(data.data.koreaSignal)
    })
  }, [refreshSummary, currentMonth])

  return (
    <>
      <NavigationBar />
      <div className="container">
        <div className="content">
          <div className="header">
            <h2>KOR NEWS<br/>INDEX</h2>
            <div className="formOption">
              <ViewType 
                defaultValue={viewType}
                onChangeHandler={viewTypeChangeHandler}
              />
              <ViewRange
                viewType={viewType}
                onChangeHandler={viewRangeHandler}
                title="kni"
              />
            </div>
          </div>
        {(loadingIndex || loadingSummary) ? (
          <ActivityIndicator />
        ) : (
          <div className='newsIndexChart'>
            <div className='chartHeader'>
              <div className='legend'>
                <span className='leg1'>KOSPI</span>
                <span className='leg2'>KOSPI EWS</span>
              </div>
              <CSVLink data={csvData} filename={csvFileName}>
                <button className='btnDownload'/>
              </CSVLink>
              
            </div>
            {koreaIndex &&
              <IndexLineChart name='KOSPI' data={koreaIndex} setTarget={setCurrentMonth} viewType={viewType}/>
            }
          {koreaSignal &&
            <div className='summaryWrap'>
              <div className='gaugeChartWrap'>
                <span className='title'>Early Warning Signal</span>
                <div className='gaugeChart border'>
                  <CustomGaugeChart signal={koreaSignal.gauge} category='kni' />
                </div>
              </div>
              <div className='summary border'>
              {koreaSignal.summery.length > 0 ? (
                koreaSignal.summery.map((summary, index) => {
                  return (
                    <div key={index} className='summaryItem'>
                      <div className='title'>{summary.title} </div>
                      <div className='contents'>{summary.content.map((c, i) => <span key={i}>{c}<br/></span>)}</div>
                    </div>
                  );
                })
              ) : (
                <div className='summaryItem'>
                  <div className='contents'>데이터가 없습니다.</div>
                </div>
              )}
              </div>
            </div>
          }
          </div>
        )}
          </div>
      </div>
    </>
  );

}; 

export default withRouter(KoreanNewsIndex);